import React,{useContext} from "react";
import { Context } from "../context/Context";
import { MutatingDots } from "react-loader-spinner";


export default function Loader() {

  const {theme} = useContext(Context);
  return (
    <div className="h-full absolute w-full max-w-500px flex items-center justify-center z-20 bg-loader-white-bg">
      <MutatingDots
        height="100"
        width="100"
        color="#FFD700"
        secondaryColor='#FFD700'
        radius='12.5'
        ariaLabel="mutating-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />

    </div>
  );
}
